import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  channels: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  cover: belongsTo('asset', { inverse: null }),
  productFamilies: hasMany('product-family', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  urlAliases: hasMany('url-alias', { inverse: null }),
});
